const ClipboardList = ({ text }) => {
	return (
		<svg
		className={text? text: "mx-2"}
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 1C13.1046 1 14 1.89543 14 3H18C19.6569 3 21 4.34315 21 6V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V6C3 4.34315 4.34315 3 6 3H10C10 1.89543 10.8954 1 12 1ZM8 5H6C5.44772 5 5 5.44772 5 6V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V6C19 5.44772 18.5523 5 18 5H16V6C16 6.55228 15.5523 7 15 7H9C8.44772 7 8 6.55228 8 6V5Z"
				fill="#33383F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7 11C7 10.4477 7.44772 10 8 10L16 10C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12L8 12C7.44772 12 7 11.5523 7 11Z"
				fill="#33383F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7 15C7 14.4477 7.44772 14 8 14L12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16L8 16C7.44772 16 7 15.5523 7 15Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default ClipboardList;
